import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, Observable, tap } from 'rxjs';

import { Parcours } from '../référentiel-métier-parcours/models/parcours.model';
import { EtapeStore } from '../référentiel-métier-parcours/parcours-etape/store/etape.store';
import { ModuleStore } from '../référentiel-métier-parcours/parcours-module/store/module.store';
import { RéférentielMétierParcoursService } from '../référentiel-métier-parcours/services/référentiel-métier-parcours.service';
import { GroupeÉtapesÀLaCarteStore } from '../référentiel-métier-parcours/store/groupe-étapes-à-la-carte/groupe-étapes-à-la-carte.store';
import { ParcoursStore } from '../référentiel-métier-parcours/store/parcours.store';

export const parcoursResolver: ResolveFn<Observable<Parcours[]> | undefined> = (route) => {
  const parcoursService = inject(RéférentielMétierParcoursService);
  const parcoursStore = inject(ParcoursStore);
  const moduleStore = inject(ModuleStore);
  const groupeÉtapesStore = inject(GroupeÉtapesÀLaCarteStore);
  const étapeStore = inject(EtapeStore);
  const slugRef = route.params['slugRef'] as string;
  const slugCarto = route.params['slugCarto'] as string;
  const idParcours = route.params['idParcours'] as string;
  const id = route.queryParamMap.get('id');
  const type = route.queryParamMap.get('type');
  const fragmentsCarto = !!slugCarto ? slugCarto.split('-') : [];
  const idCartographie = fragmentsCarto.length ? fragmentsCarto[0] : '';

  const fragmentsRef = !!slugRef ? slugRef.split('-') : [];
  const idReferentiel = fragmentsRef.length ? fragmentsRef[0] : '';
  const idModule = route.paramMap.get('idModule');
  const module = idModule ?? id;

  return parcoursService.trouverTous(idCartographie, idReferentiel).pipe(
    map((parcours) => parcours.items),
    tap((parcours) => {
      const parcoursCourant = parcours.find((x) => x.id === idParcours) ?? parcours[0];
      moduleStore.chargerModules(parcoursCourant.noeuds.flatMap((x) => x.modules));
      groupeÉtapesStore.chargerGroupes({ groupes: parcoursCourant.groupesEtapesALaCarte });
      étapeStore.chargerEtapes({ etapes: parcoursCourant.noeuds });
      parcoursStore.chargerParcours({ parcours });
      parcoursStore.select({ id: parcoursCourant.id });
    }),
    tap(() => {
      if (type !== 'module') {
        moduleStore.unselect();
      } else if (module && type === 'module') {
        moduleStore.selection(module);
      }
    }),
    tap(() => {
      if (!id || type !== 'étape') {
        étapeStore.unselect();
      } else if (id && type === 'étape') {
        étapeStore.selection(id);
      }
    }),
  );
};
